import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Fragment, Suspense, lazy, useCallback, useState } from "react";

import { alpha, styled } from "@mui/material/styles";

import LogoutIcon from "@mui/icons-material/Logout";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { logoutAction } from "../../store/actions/auth";

const Dialog = lazy(() => import("../../components/Dialog"));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    mt: 1,
    overflow: "visible",
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 250,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function AuthMenu({ handleClose, user, anchorEl }) {
  const { t } = useTranslation(["global"]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { image, color, firstName, lastName } = user;

  const [confirmMenu, setConfirmMenu] = useState({
    open: false,
    onConfirm: () => {},
    title: "",
    subTitle: "",
    okText: "",
    cancelText: "",
  });
  const closeConfirm = useCallback(
    () =>
      setConfirmMenu(() => ({
        open: false,
      })),
    []
  );

  const logout = useCallback(() => {
    logoutAction()(dispatch);
    closeConfirm();
    handleClose();
  }, [dispatch, closeConfirm, handleClose]);

  const openLogoutDialog = useCallback(
    () =>
      setConfirmMenu({
        open: true,
        title: t("logout"),
        subTitle: t("logout_body"),
        okText: t("logout"),
        cancelText: t("cancel"),
        onConfirm: logout,
      }),
    [logout, t]
  );

  return (
    <>
      {confirmMenu.open && (
        <Suspense fallback={<Fragment />}>
          <Dialog
            open={confirmMenu.open}
            onConfirm={confirmMenu.onConfirm}
            close={closeConfirm}
            okText={confirmMenu.okText}
            cancelText={confirmMenu.cancelText}
            title={confirmMenu.title}
            subTitle={confirmMenu.subTitle}
            removeTitleSpace
          />
        </Suspense>
      )}
      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 10,
              width: 24,
              height: 24,
              borderRadius: "6px",
              backgroundColor: "background.paper",
              transform: "translateY(-30%) rotate(-45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        {/* <MenuItem
              onClick={
                themeVersion === "space"
                  ? nav("/profile")
                  : nav("/settings?tab=profile")
              }
              disableRipple
            >
              <Box sx={{ mr: 1.5 }}>
                <UserAvatar
                  alt={firstName}
                  color={color}
                  src={image}
                  sx={{ width: "56px", height: "56px" }}
                />
              </Box>
              <Box>
                <Typography fontWeight="bold">
                  {firstName + " " + lastName}
                </Typography>
                <Typography color="text.secondary" variant="subtitle2">
                  {t("view_profile")}
                </Typography>
              </Box>
            </MenuItem> */}
        {/* <MenuItem onClick={nav("/")} disableRipple>
              <Box sx={{ mr: 2 }}>
                <img src={authHome} alt="" />
              </Box>
              {t("home")}
            </MenuItem> */}
        {/* <MenuItem onClick={() => navigate("/my-video")}>
          My Interactive videos
        </MenuItem> */}

        <MenuItem onClick={openLogoutDialog} disableRipple>
          <Box sx={{ mr: 2 }}>
            <LogoutIcon />
          </Box>
          <Typography color="error">{t("logout")}</Typography>
        </MenuItem>
      </StyledMenu>
    </>
  );
}
